export function CancelDelete(accountID: number): string {
	return `/v1/accounts/${accountID}/cancel-delete`;
}

export function CancelEmailChange(): string {
	return `/v1/me/pending-email`;
}

export function ConfirmEmail(): string {
	return `/v1/me/confirm-email`;
}

export function Create(): string {
	return `/v1/accounts`;
}

export function CreateChildAccountForAccount(accountID: number): string {
	return `/v1/accounts/${accountID}/create-child-account`;
}

export function CreateRelation(accountID: number): string {
	return `/v1/accounts/${accountID}/relations`;
}

export function Delete(accountID: number): string {
	return `/v1/accounts/${accountID}`;
}

export function DeleteRelation(accountID: number, targetAccountID: number): string {
	return `/v1/accounts/${accountID}/relations/${targetAccountID}`;
}

export function GrantParentalConsent(accountID: number): string {
	return `/v1/accounts/${accountID}/parental-consent`;
}

export function GrantParentalConsentWithToken(): string {
	return `/v1/parental-consent`;
}

export function OnboardingInfo(): string {
	return `/v1/onboarding-info`;
}

export function RemoveParentalConsent(accountID: number): string {
	return `/v1/accounts/${accountID}/parental-consent`;
}

export function RemoveParentalConsentWithToken(): string {
	return `/v1/parental-consent`;
}

export function ResendEmailChange(): string {
	return `/v1/me/resend-email-change`;
}

export function ResendVerification(): string {
	return `/v1/accounts/resend-verification`;
}

export function ResetPassword(): string {
	return `/v1/reset-password`;
}

export function ShowParentalConsent(): string {
	return `/v1/parental-consent`;
}

export function SwapRelation(accountID: number): string {
	return `/v1/accounts/${accountID}/relations/swap`;
}

export function Update(accountID: number): string {
	return `/v1/accounts/${accountID}`;
}

export function VerifyEmail(): string {
	return `/v1/accounts/verify-email`;
}

